module.exports = __webpack_public_path__ + "c2891c9d45d4ed83185ed323605bbbc1.png";